module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/mapped-tables/mapped-tables.component.scss
// module id = ./src/app/mapped-tables/mapped-tables.component.scss
// module chunks = main